import { format } from 'owa-localize';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import AttachmentWellViewState from 'owa-attachment-well-data/lib/schema/AttachmentWellViewState';

const nameTemplate = '{0}; ';

export default function getAttachmentCollectionString(
    attachmentWell: AttachmentWellViewState
): string {
    let result: string = '';

    const attachments = [
        ...attachmentWell.docViewAttachments,
        ...attachmentWell.imageViewAttachments,
    ];

    attachments.forEach(attachment => {
        const attachmentModel = getAttachment(attachment.attachmentId);

        if (attachmentModel) {
            result += format(nameTemplate, attachmentModel.model.Name);
        }
    });

    return result;
}
